import { useEffect } from 'react'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { PricingPlans } from '@/components/pricing-plans/PricingPlans.jsx'
import { AnalyticsService } from '@/services/analytics.js'

export const PricingPlansDialog = ({ isOpen, setIsOpen }) =>  {

    useEffect(() => {
        if (isOpen) {
            AnalyticsService.track('pricing-plans-dialog-opened')
        }
    }, [])

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogContent className="sm:max-w-[95%] bg-main-surface bg-center bg-cover bg-no-repeat overflow-hidden">
                <DialogHeader>
                    <DialogTitle>Choose Your Plan</DialogTitle>
                    <DialogDescription>
                        Select the perfect plan for your needs. Upgrade or downgrade at any time.
                    </DialogDescription>
                </DialogHeader>
                <PricingPlans
                    onCheckoutOpened={setIsOpen}
                    onSubscriptionCancelled={setIsOpen}
                />
            </DialogContent>
        </Dialog>
    )
}

